/**
 * National Preparedness Month — rotating image callout cards.
 * Fade-in-up / fade-out-up crossfade; display pause is configurable via data attributes.
 * Case: paused in Shopify theme editor so each callout block stays selectable.
 */
(function () {
  "use strict";

  var ROTATOR_SELECTOR = "[data-sfs-npm-callout]";
  var SLIDE_SELECTOR = ".sfs-npm__callout-slide";
  var ACTIVE_CLASS = "is-active";
  var EXIT_CLASS = "is-exiting";
  var DEFAULT_DISPLAY_MS = 6000;
  var DEFAULT_TRANSITION_MS = 500;

  /**
   * @param {HTMLElement} rotator
   */
  function initRotator(rotator) {
    if (document.documentElement.classList.contains("shopify-design-mode")) {
      return;
    }

    var reduceMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var slides = rotator.querySelectorAll(SLIDE_SELECTOR);
    if (slides.length < 2 || reduceMotion) {
      if (slides.length === 1) {
        slides[0].classList.add(ACTIVE_CLASS);
      }
      return;
    }

    var displayMs = parseInt(rotator.getAttribute("data-display-ms"), 10);
    var transitionMs = parseInt(rotator.getAttribute("data-transition-ms"), 10);
    if (!displayMs || displayMs < 1000) displayMs = DEFAULT_DISPLAY_MS;
    if (!transitionMs || transitionMs < 200) transitionMs = DEFAULT_TRANSITION_MS;

    rotator.style.setProperty("--sfs-npm-callout-transition-ms", transitionMs + "ms");

    var index = 0;
    var timerId = null;

    slides[0].classList.add(ACTIVE_CLASS);

    /**
     * @param {number} nextIndex
     */
    function goTo(nextIndex) {
      var current = slides[index];
      var next = slides[nextIndex];
      if (!current || !next || current === next) return;

      current.classList.add(EXIT_CLASS);
      current.classList.remove(ACTIVE_CLASS);
      next.classList.add(ACTIVE_CLASS);

      window.setTimeout(function () {
        current.classList.remove(EXIT_CLASS);
      }, transitionMs);

      index = nextIndex;
    }

    function scheduleNext() {
      timerId = window.setTimeout(function () {
        goTo((index + 1) % slides.length);
        scheduleNext();
      }, displayMs);
    }

    scheduleNext();

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        if (timerId) {
          clearTimeout(timerId);
          timerId = null;
        }
      } else if (!timerId) {
        scheduleNext();
      }
    });
  }

  function boot() {
    var rotators = document.querySelectorAll(ROTATOR_SELECTOR);
    for (var i = 0; i < rotators.length; i++) {
      initRotator(rotators[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
